
import React from 'react';
import { Line,Bar,Pie,Doughnut } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    ArcElement,
    
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

// Register the components you want to use
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    BarElement,
    ArcElement,
    Title,
    Tooltip,
    Legend
);

const LeadsPieChart = ({values ,labels,legend=false,backgroundColor}) => {
    const data =  {
        labels:labels?.length>0?labels: [
            'Facebook',
            'Instagram',
            'LinkedIn'

          ],
          datasets: [{
            label: '',
            data:values?.length>0?values: [1,1,1],
            backgroundColor:backgroundColor?.length>0? backgroundColor:[
              '#D3A4FF',
              '#FFB1E0',
              '#95F3FA',
            
            ],
            hoverOffset: 4
          }]
    }

    const options = {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
         
            
        },
        plugins: {
            legend: {
                display: legend ,
                position:'bottom'
            }
        }

    }


 return <Doughnut  data={data} options={options}  height={"50%"} />;


};

export default LeadsPieChart;
